export default __webpack_public_path__ + "static/media/rs-arte-5.21f6ceac.webp";